/*
Our password policy is as follows:

- Minimum length, which must be at least 10 characters but fewer than 99 characters
- Require numbers
- Require uppercase letters
- Require lowercase letters
- Require a special character from this set: -^$*.[]{}()?"!@#%&/\,><':;|_~`
- + and = are allowed but aren't classed as special characters
- Space characters are allowed but aren't classed as special characters

- Note: Minus is recognised by Cognito as a special character even though the 
  docs explicitly say it isn't. 
  
  Docs are here: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
*/

export function isPasswordValid(value: string) {
  return (
    checkHasValidLength(value) &&
    checkHasNumbers(value) &&
    checkHasUppercase(value) &&
    checkHasLowercase(value) &&
    checkHasSpecial(value)
  );
}

export function checkHasValidLength(value: string) {
  return value?.length > 9 && value?.length < 99;
}

export function checkHasNumbers(value: string) {
  return new RegExp(/[0-9]/).test(value);
}

export function checkHasSpecial(value: string) {
  return /[-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/.test(value);
}

export function checkHasUppercase(value: string) {
  return new RegExp(/[A-Z]/).test(value);
}

export function checkHasLowercase(value: string) {
  return new RegExp(/[a-z]/).test(value);
}
